module.exports = __webpack_public_path__ + "img/img_throw_6@2x.55c4577d.png";